(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wishlist-heart"] && !Shopify.designMode) return;
  try {
    class WishlistHeart extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'lumaku-wishlist';
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.productId = this.dataset.productId;
    this.updateState();
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    });
  }

  getWishlist() {
    try {
      var raw = localStorage.getItem(this.storageKey);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  updateState() {
    var list = this.getWishlist();
    var active = list.indexOf(this.productId) !== -1;
    this.dataset.active = active;
    this.button.setAttribute('aria-pressed', active);
  }

  toggle() {
    var list = this.getWishlist();
    var index = list.indexOf(this.productId);
    if (index !== -1) {
      list.splice(index, 1);
    } else {
      list.push(this.productId);
    }
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(list));
    } catch (e) {}
    this.updateState();
  }
}

if (!customElements.get('wishlist-heart')) {
  customElements.define('wishlist-heart', WishlistHeart);
}
  } catch(e) { console.error(e); }
})();

})();
